<template>
  <div class='AdmHeader'>
    <div class="cont-check" :style="{ width: checkbox ? '3%' : '1%' }">
      <input :checked="check" type="checkbox"
      @change="e => {
        $emit('toggle', !check)
      }"
      v-if="checkbox"
      >
    </div>
    <div
    class="head"
    v-for="(h, key) in headers"
    :key="key"
    :style="{ width: h.width }"
    >
      {{ h.text }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AdmHeader',
  props: {
    headers: {
      type: Array,
      default: () => ([ { text: 'text', width: '10%' } ])
    },
    checkbox: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    ...mapGetters(['listItemSelected']),
    check () {
      return this.listItemSelected.length === this.list.length
    }
  }
}
</script>

<style scoped>
.AdmHeader {
  display: flex;
  align-items: center;
  justify-content: left;
  height: 30px;
  background-color: #EEEEEE;
}
.cont-check {
  width: 2%;
}
.head {
  text-align: left;
  font-size: 12px;
  font-weight: bold;
}
</style>

